window.MapRoutes = {
  routeInfo: { distance: 0, duration: 0 },
  gmap: null,

  showRoute () {
    let pointFrom = new RoutePoint('from', true)
    let pointTo = new RoutePoint('to', true)

    this.gmap = new GMap('gmap', true)

    if (!pointFrom.positionPoint) return

    this.gmap.setMarker('from', pointFrom.position)

    if (!pointTo.positionPoint) return

    this.gmap.setMarker('to', pointTo.position)
  },

  getPositionsLatLng: function(from, to) {
    const getLatLng = ({ position }) => new google.maps.LatLng(
      Number(position[0]), Number(position[1])
    )

    return [
      getLatLng(from),
      getLatLng(to)
    ]
  },

  changeMetrics: function(){
    var $routeInfoTable = $('.gmap-table'),
        postfix = $routeInfoTable.data('postfix');
    if (
      $routeInfoTable.length > 0 &&
      postfix &&
      this.routeInfo &&
      this.routeInfo.distance
    ) {
      var $distanceUnit = $('#menu-distance-units .drop-menu-item_selected').data();
      var metric = postfix[$distanceUnit.value];

      var distance = Math.round(this.routeInfo.distance * $distanceUnit.kmRate);

      var minutes = this.routeInfo.duration;
      var hours = minutes / 60;
      var hoursStr = Math.floor(hours);
      var minutesStr = minutes % 60;
      minutesStr = (minutesStr < 10 ? '0' : '') + minutesStr;

      var speed = parseInt(distance / hours);
      var timeStr = [hoursStr, postfix.h, minutesStr, postfix.min].join(' ');
      $('#route_time').text(timeStr);
      $('#route_distance').text(distance + ' ' + metric);
      $('#route_speed').text(speed + ' ' + metric + ' / ' + postfix.h);
      $('.double').toggleClass('show-double', $('#return_way').prop('checked'));
    }
  },

  createArrowIcon: function(fillColor, rotation) {
    return {
      path: 'M 0,0 L -5, 15 L 5,15 z',
      fillColor,
      fillOpacity: 1,
      scale: 1,
      strokeColor: '#000000',
      strokeWeight: 1,
      rotation,
      anchor: new google.maps.Point(0, 5)
    };
  },

  setLocations: function(locations) {
    locations.forEach(location => {
      let marker = new google.maps.Marker({
        position: { lat: location.latitude, lng: location.longitude },
        map: this.gmap.map,
        icon: this.createArrowIcon(location.state ? '#EE2222' : '#4285F4', location.heading),
      });

      let content = '';
      for (const [key, value] of Object.entries(location)) {
        content += `${key} = ${value}<br>`;
      }

      const infoWindow = new google.maps.InfoWindow({ content });

      marker.addListener('click', () => {
        infoWindow.open(this.gmap.map, marker);
      });
    })
  },

  errorShowHide: function(id) {
    return function () {
      var $hiddenInput = $('#point' + id);
      var $visibleInput = $hiddenInput.parent().find('.inputTransferPoint');
      $visibleInput.toggleClass('show-error', !$hiddenInput.val());
    };
  },

  setCarrierMarker (coordinates) {
    this.gmap.setCarrierMarker(coordinates);
  },

  destroy () {
    this.gmap.destroy();
  },
};
